import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';

import { parseInitialSharedCoords } from '../helpers';
import { useLayer } from '../components/LayerContext/useLayer';
import { GET_PUBLIC_SHARED_MAP_QUERY, GET_SHARED_MAP_QUERY } from '../gql';

const getSharedMapFromData = (data) =>
  data?.getSharedMap ?? data?.getPublicSharedMap;

const useLoadShared = ({ setSharedMap, isSignedIn }) => {
  const navigate = useNavigate();
  const { shareSlug } = useParams();
  const { setLayer } = useLayer();

  const { loading: sharedMapLoading, data: sharedMapData } = useQuery(
    isSignedIn ? GET_SHARED_MAP_QUERY : GET_PUBLIC_SHARED_MAP_QUERY,
    {
      fetchPolicy: 'cache-first',
      variables: { slug: shareSlug },
      skip: !shareSlug,
      onCompleted: (d) => {
        const sharedMap = getSharedMapFromData(d);
        if (!sharedMap) return;

        const { initialCoords } = parseInitialSharedCoords(
          sharedMap?.settings?.mapSettings
        );

        setSharedMap({
          markerPoints: sharedMap?.settings?.markerPoints,
          sharedInitialCoordinates: initialCoords,
          loadedShareSlug: shareSlug,
        });

        setLayer(sharedMap?.settings?.mapSettings?.layer);
      },
    }
  );

  useEffect(() => {
    if (!shareSlug) return;
    if (sharedMapLoading) return;
    if (getSharedMapFromData(sharedMapData)) return;
    navigate('/');
  }, [navigate, shareSlug, sharedMapLoading, sharedMapData]);

  return {
    sharedMapLoading,
  };
};

export { useLoadShared };
